var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudySunLm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2418 10.0385C22.5233 10.2014 22.8867 10.1252 23.0641 9.85261L23.7428 8.80963C23.9606 8.47497 23.8677 8.02596 23.5221 7.82598C23.1766 7.62599 22.739 7.7682 22.5574 8.12381L21.9916 9.23208C21.8437 9.52178 21.9602 9.87557 22.2418 10.0385Z",
    fill: "#FBB930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6164 8.53284C16.9417 8.53284 17.2188 8.2846 17.2355 7.95971L17.2997 6.71492C17.3202 6.31738 17.0145 5.97656 16.6164 5.97656C16.2183 5.97656 15.9125 6.31738 15.933 6.71492L15.9972 7.9597C16.014 8.2846 16.291 8.53284 16.6164 8.53284Z",
    fill: "#FBB930"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.991 10.0385C11.2725 9.87557 11.3891 9.52179 11.2412 9.23208L10.6753 8.12381C10.4938 7.7682 10.0562 7.62599 9.71062 7.82598C9.36504 8.02596 9.27216 8.47497 9.48993 8.80963L10.1686 9.85261C10.346 10.1252 10.7094 10.2014 10.991 10.0385Z",
    fill: "#FBB930"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87443 14.155C7.03735 13.8735 6.96118 13.5101 6.68854 13.3327L5.64556 12.654C5.3109 12.4362 4.8619 12.5291 4.66191 12.8747C4.46193 13.2203 4.60414 13.6578 4.95975 13.8394L6.06802 14.4052C6.35772 14.5531 6.71151 14.4366 6.87443 14.155Z",
    fill: "#FBB930"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79564 19.1613C5.12054 19.1781 5.36877 19.4551 5.36877 19.7804C5.36877 20.1058 5.12054 20.3828 4.79564 20.3996L3.55086 20.4638C3.15331 20.4843 2.8125 20.1785 2.8125 19.7804C2.8125 19.3824 3.15331 19.0766 3.55086 19.0971L4.79564 19.1613Z",
    fill: "#FBB930"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0261 12.8253C21.3408 11.2714 19.0895 10.3222 16.6164 10.3222C11.3928 10.3222 7.15817 14.5568 7.15817 19.7804C7.15817 20.1622 7.18079 20.5386 7.22475 20.9085C8.75336 19.909 10.5804 19.3279 12.5431 19.3279C13.3391 19.3279 14.1138 19.4237 14.856 19.6047C16.4989 16.3423 19.4522 13.8514 23.0261 12.8253Z",
    fill: "#FBB930"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5431 37.6576C7.79394 37.6576 3.94397 33.8076 3.94397 29.0585C3.94397 24.3093 7.79394 20.4593 12.5431 20.4593C13.5729 20.4593 14.5604 20.6403 15.4755 20.9723C17.281 16.5559 21.6204 13.4442 26.6864 13.4442C33.3728 13.4442 38.7931 18.8646 38.7931 25.5509C38.7931 25.8455 38.7826 26.1376 38.7619 26.4268C40.7839 27.3579 42.1875 29.402 42.1875 31.774C42.1875 35.0234 39.5533 37.6576 36.3039 37.6576H12.5431Z",
    fill: "#A3B6C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudySunLm);
export default __webpack_public_path__ + "static/media/cloudy-sun-lm.79f11017bc6ccb31c7bd26384e8411bb.svg";
export { ForwardRef as ReactComponent };